// eslint-disable-next-line no-magic-numbers
export const easeOutSine = time => Math.sin(time * (Math.PI / 2));

// eslint-disable-next-line no-param-reassign, no-plusplus, no-param-reassign, no-mixed-operators, no-magic-numbers
export const easeOutCubic = time => --time * time * time + 1;

